<template>
  <b-card
    v-if="articlesEdit"
    class="blog-edit-wrapper"
  >

    <!-- form -->
     <!-- <validation-observer ref="ariclesValidation"> -->
      <b-form class="mt-2">
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Title"
              label-for="blog-edit-title"
              class="mb-2"
            >
              <b-form-input
                id="blog-edit-title"
                v-model="articlesEdit.title"
              />
            </b-form-group>
          </b-col>
       
          <b-col cols="12">
            <b-form-group
              label="Content"
              label-for="blog-content"
              class="mb-2"
            >
              <editor
                v-model="articlesEdit.body"
                api-key="iw2d576uwxj9tjfd66mq9bpa2frzhy7e6oks8nhpkiyt58v3"
                :init="{
                  height: 500,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                  ],
                  table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                  toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat | table | help'
                }"
              />
            </b-form-group>
          </b-col>
         
          <b-col
            cols="12"
            class="mt-50"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              @click="validationForm"
            >
              Enregistrer
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
            >
              Annuler
            </b-button>
          </b-col>
        </b-row>
      </b-form>
     <!-- </validation-observer> -->
    <!--/ form -->
  </b-card>
</template>

<script>

import Editor from '@tinymce/tinymce-vue'

import {
  BCard, BMedia, BAvatar, BCardText, BMediaAside, BMediaBody, BForm, BRow, BCol, BFormGroup, BFormInput, BImg, BFormFile, BLink, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import axios from 'axios'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  data() {
    return {
      articlesEdit: {
        title: '',
        body: '',
        featuredImage: '',
      },
      blogFile: null,
      categoryOption: ['Fashion', 'Food', 'Gaming', 'Quote', 'Video'],
      statusOption: ['Published', 'Pending', 'Draft'],
      snowOption: null,
      tableModule: null
    }
  },
  computed: {
  },
  mounted() {
  },
  components: {
    'editor': Editor,
    BCard,
    BMedia,
    BAvatar,
    BCardText,
    BMediaAside,
    BMediaBody,
    BForm,
    BLink,
    BImg,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormFile,
    vSelect,
  },
  directives: {
    Ripple,
  },
  created() {
    // this.editor.insertTable(3, 3)
    // this.$http.get('/blog/list/data/edit').then(res => { this.articlesEdit = res.data })
  },
  setup() {
    const refInputEl = ref(null)
    const refPreviewEl = ref(null)
    const quillPreviewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => { refPreviewEl.value.src = base64 })

    return {
      refInputEl,
      refPreviewEl,
      quillPreviewEl,
      inputImageRenderer,
    }
  },
  methods: {
    validationForm() {

      try {
        axios.post('https://admin.ordredespharmaciens.sn/api/v1/dashboard/new-articles', this.articlesEdit).then(res => { 
          // console.log(res);
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Articles`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: `Votre nouvel article a été publié avec succès !`,
            },
          })
          this.$router.replace("/articles/list");
        })
      } catch (error) {
        console.log("error", error);
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/page-blog.scss';
</style>
